/* tslint:disable */
/* eslint-disable */
/**
 * Easy Invoices API v1
 * The Easy Invoices API for Shopify embedded app - automatic invoice generation and export functionality
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { SupportAdminMessageDtoAttachmentsInner } from './support-admin-message-dto-attachments-inner';

/**
 * 
 * @export
 * @interface SupportAdminMessageDto
 */
export interface SupportAdminMessageDto {
    /**
     * 
     * @type {string}
     * @memberof SupportAdminMessageDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SupportAdminMessageDto
     */
    'authorType': SupportAdminMessageDtoAuthorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SupportAdminMessageDto
     */
    'authorName': string;
    /**
     * 
     * @type {string}
     * @memberof SupportAdminMessageDto
     */
    'body': string;
    /**
     * PUBLIC messages are visible to the merchant; INTERNAL notes never are.
     * @type {string}
     * @memberof SupportAdminMessageDto
     */
    'visibility': SupportAdminMessageDtoVisibilityEnum;
    /**
     * 
     * @type {Array<SupportAdminMessageDtoAttachmentsInner>}
     * @memberof SupportAdminMessageDto
     */
    'attachments': Array<SupportAdminMessageDtoAttachmentsInner>;
    /**
     * 
     * @type {string}
     * @memberof SupportAdminMessageDto
     */
    'createdAt': string;
}

/**
    * @export
    * @enum {string}
    */
export enum SupportAdminMessageDtoAuthorTypeEnum {
    Customer = 'CUSTOMER',
    Agent = 'AGENT',
    System = 'SYSTEM'
}
/**
    * @export
    * @enum {string}
    */
export enum SupportAdminMessageDtoVisibilityEnum {
    Public = 'PUBLIC',
    Internal = 'INTERNAL'
}


